import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext();

const SUPPORTED_LANGS = ["zh-TW", "zh-CN", "en", "en-GB"];
const DEFAULT_LANG = "en";

function getInitialLang() {
  const saved = localStorage.getItem("language");
  return SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLang());
  const [componentLanguageData, setComponentLanguageData] = useState({});

  // ✅ 指定語言或循環切換（不傳參數時）
  const changeLanguage = (nextLang) => {
    let newLang = nextLang && SUPPORTED_LANGS.includes(nextLang)
      ? nextLang
      : // 若未傳參數，循環切換：zh-TW -> zh-CN -> en -> en-GB -> zh-TW
        (language === "zh-TW" ? "zh-CN" : language === "zh-CN" ? "en" : language === "en" ? "en-GB" : "zh-TW");

    localStorage.setItem("language", newLang);
    setLanguage(newLang);
  };

  // 動態載入語系：你的 Init(language) 已經會依目前語系回傳內容（維持不變）
  const loadLanguageFile = async (componentKey, langFilePath) => {
    try {
      const langModule = await import(`../components/language/${langFilePath}.js`);
      setComponentLanguageData((prev) => ({
        ...prev,
        [componentKey]: langModule.Init(language) || { Main: {} },
      }));
    } catch (error) {
      console.error(`❌ 無法載入語言檔案: ${langFilePath}`, error);
      setComponentLanguageData((prev) => ({
        ...prev,
        [componentKey]: { Main: {} },
      }));
    }
  };

  // ✅ 當語言變更時，更新 <html lang> 與 <body data-lang>
  useEffect(() => {
    document.documentElement.setAttribute("lang", language === "zh-CN" ? "zh-CN" : language === "zh-TW" ? "zh-Hant-TW" : language === "en-GB" ? "en-GB" : "en");
    document.body.setAttribute("data-lang", language);
  }, [language]);

  // ✅ 多分頁同步（可選）
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "language" && e.newValue && SUPPORTED_LANGS.includes(e.newValue)) {
        setLanguage(e.newValue);
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, componentLanguageData, changeLanguage, loadLanguageFile }}>
      {children}
    </LanguageContext.Provider>
  );
};
